module.exports = __webpack_public_path__ + "img/tu_03.3553f201.png";